export default __webpack_public_path__ + "static/P_SearchThumb_PowerOverEthernet-f40241f2886dbde0f526bacc8db5ae79.webp";